import React from 'react';
import { renderToString } from 'react-dom/server';
import { colors } from '@alixpartners/ui-components';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Boost from 'highcharts/modules/boost';
import {
	formatSpendWithDecimalAndSymbol,
	getFormattedPercentage,
} from 'utils/number';
import {
	ChartContainer,
	TooltipColor,
	TooltipContainer,
	TooltipItem,
	TooltipItemName,
	TooltipItemTitle,
	TooltipItemValue,
	// LegendContainer,
	// LegendItem,
	// LegendColor,
	// LegendColorLine,
	// LegendColorDot,
	// LegendName,
} from './styles';
import numeral from 'numeral';
// import { makeUnknownFromEmpty } from 'Investigate/utils';

Boost(Highcharts);

const getPlotLines = series =>
	series
		.map(serie => {
			const dataObj = serie.data.find(item => item.y > 80);
			if (dataObj) {
				return {
					color: serie.color,
					width: 1,
					value: dataObj.x,
					dashStyle: 'Dash',
				};
			}
			return null;
		})
		.filter(o => o);

export const SpendByVendorChart = ({
	chartRef,
	currencySymbol,
	series,
	isSku,
	width = '100%',
	hideDecimals,
}) => {
	const chartOptions = {
		chart: {
			type: 'spline',
		},
		boost: {
			useGPUTranslations: true,
			usePreAllocated: true,
		},
		title: {
			text: isSku ? '' : 'Dashed line shows a 80% point per each company',
			style: {
				color: colors.grey5,
				fontSize: '13px',
			},
		},
		credits: { enabled: false },
		exporting: {
			enabled: false,
			fallbackToExportServer: false,
		},
		xAxis: {
			crosshair: {
				dashStyle: 'Dash',
			},
			title: {
				enabled: false,
			},
			labels: {
				formatter: function() {
					return numeral(this.value).format('0,0');
				},
			},
			plotLines: getPlotLines(series),
		},
		yAxis: {
			title: {
				align: 'high',
				text: 'Spend %',
				textAlign: 'right',
				rotation: 0,
				y: -20,
				x: 40,
			},
			labels: {
				formatter: function() {
					return getFormattedPercentage(this.value);
				},
			},
			lineWidth: 2,
		},
		legend: {
			enabled: false,
		},
		tooltip: {
			crosshairs: true,
			shared: true,
			useHTML: true,
			backgroundColor: colors.white,
			borderWidth: 0,
			borderRadius: 2,
			formatter: function() {
				return renderToString(
					<TooltipContainer>
						<TooltipItemTitle>
							{this.x} {isSku ? ' SKU' : ' vendors'}
						</TooltipItemTitle>
						{this.points.map(item => (
							<TooltipItem key={`${item.point.series.name}-${item.point.y}`}>
								<span>
									<TooltipColor color={item.color} />
									<TooltipItemName>{item.point.series.name}</TooltipItemName>
								</span>
								<TooltipItemValue>
									{getFormattedPercentage(item.point.y)} ({formatSpendWithDecimalAndSymbol(
										item.point.spend,
										currencySymbol,
										hideDecimals,
										2
									).toUpperCase()})
								</TooltipItemValue>
							</TooltipItem>
						))}
					</TooltipContainer>
				);
			},
		},
		plotOptions: {
			spline: {
				lineWidth: 3,
			},
			series: {
				turboThreshold: 1000000000,
				marker: {
					states: {
						hover: {
							lineWidthPlus: 0,
							radiusPlus: 0,
						},
					},
					enabled: false,
					symbol: 'circle',
					radius: 6,
					radiusPlus: 0,
				},
				animation: false,
				dataGrouping: {
					enabled: true,
					approximation: 'average',
				},
			},
		},
		series,
	};
	return (
		<ChartContainer width={width}>
			<HighchartsReact
				highcharts={Highcharts}
				options={chartOptions}
				ref={chartRef}
			/>
			{/* <LegendContainer>
				{series.map(serie => (
					<LegendItem key={`${serie.name}`}>
						<LegendColor color={serie.color}>
							<LegendColorLine color={serie.color} />
							<LegendColorDot color={serie.color} />
						</LegendColor>
						<LegendName>{makeUnknownFromEmpty(serie.name)}</LegendName>
					</LegendItem>
				))}
			</LegendContainer> */}
		</ChartContainer>
	);
};

export default SpendByVendorChart;
